import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faSearchLocation, faHeadset, faLanguage, faRocket, faRobot, faPlug, faGlobe, faCheck } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticSolutionSection.css';
import aiVirtualAssistant from "../../assets/app/Logistic/ai-virtual-assistant.png";
import { useTranslation } from "react-i18next";

const LogisticSolutionSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-solution-section" id="como-funciona">
      <div className="logistic-container">
        {/* Banner de IA en acción */}
        <div className="logistic-solution-banner">
          <img src={aiVirtualAssistant} alt={t('LogisticSolutionSection:alt_text')} loading="lazy" />
        </div>
        
        <div className="logistic-section-header">
          <span className="logistic-section-tag">{t('LogisticSolutionSection:section_tag')}</span>
          <h2 >{t('LogisticSolutionSection:title_prefix')} <span className="logistic-text-primary">{t('LogisticSolutionSection:title_strong')}</span></h2>
          <p >{t('LogisticSolutionSection:subtitle')}</p>
        </div>

        <div className="logistic-solution-hero">
          <div className="logistic-solution-visual">
            <div className="logistic-ai-brain">
              <div className="logistic-brain-core">
                <FontAwesomeIcon icon={faBrain} />
                <div className="logistic-pulse-ring"></div>
                <div className="logistic-pulse-ring logistic-delay-1"></div>
                <div className="logistic-pulse-ring logistic-delay-2"></div>
              </div>
              <div className="logistic-connection-line logistic-line-1"></div>
              <div className="logistic-connection-line logistic-line-2"></div>
              <div className="logistic-connection-line logistic-line-3"></div>
              <div className="logistic-connection-line logistic-line-4"></div>
              
              <div className="logistic-capability logistic-cap-1">
                <div className="logistic-capability-icon">
                  <FontAwesomeIcon icon={faSearchLocation} />
                </div>
                <span>{t('LogisticSolutionSection:capability1')}</span>
              </div>
              <div className="logistic-capability logistic-cap-2">
                <div className="logistic-capability-icon">
                  <FontAwesomeIcon icon={faHeadset} />
                </div>
                <span>{t('LogisticSolutionSection:capability2')}</span>
              </div>
              <div className="logistic-capability logistic-cap-3">
                <div className="logistic-capability-icon">
                  <FontAwesomeIcon icon={faLanguage} />
                </div>
                <span>{t('LogisticSolutionSection:capability3')}</span>
              </div>
              <div className="logistic-capability logistic-cap-4">
                <div className="logistic-capability-icon">
                  <FontAwesomeIcon icon={faRocket} />
                </div>
                <span>{t('LogisticSolutionSection:capability4')}</span>
              </div>
            </div>
          </div>

          <div className="logistic-solution-benefits">
            <div className="logistic-benefit-card logistic-featured">
              <div className="logistic-benefit-icon">
                <FontAwesomeIcon icon={faRobot} />
              </div>
              <h3>{t('LogisticSolutionSection:benefit1_title')}</h3>
              <ul>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticSolutionSection:benefit1_item1')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticSolutionSection:benefit1_item2')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticSolutionSection:benefit1_item3')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticSolutionSection:benefit1_item4')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticSolutionSection:benefit1_item5')}</li>
                <li><FontAwesomeIcon icon={faCheck} /> {t('LogisticSolutionSection:benefit1_item6')}</li>
              </ul>
            </div>

            <div className="logistic-benefit-card">
              <div className="logistic-benefit-icon">
                <FontAwesomeIcon icon={faPlug} />
              </div>
              <h3>{t('LogisticSolutionSection:benefit2_title')}</h3>
              <p>{t('LogisticSolutionSection:benefit2_text')}<strong>{t('LogisticSolutionSection:benefit2_strong')}</strong></p>
            </div>

            <div className="logistic-benefit-card">
              <div className="logistic-benefit-icon">
                <FontAwesomeIcon icon={faGlobe} />
              </div>
              <h3>{t('LogisticSolutionSection:benefit3_title')}</h3>
              <p>{t('LogisticSolutionSection:benefit3_text')}<strong>{t('LogisticSolutionSection:benefit3_strong')}</strong></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticSolutionSection;